export default {
  DANGER: 'alert-danger',
  SUCCESS: 'alert-success',
  WARNING: 'alert-warning',
};
